/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Team } from '../models/Team';
import type { TeamAdminSettingsRequest } from '../models/TeamAdminSettingsRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TeamService {
    /**
     * @returns Team OK
     * @throws ApiError
     */
    public static getApiTeam(): CancelablePromise<Array<Team>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Team',
        });
    }
    /**
     * @param code
     * @returns Team OK
     * @throws ApiError
     */
    public static getApiTeam1(
        code: string,
    ): CancelablePromise<Team> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Team/{code}',
            path: {
                'code': code,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Team OK
     * @throws ApiError
     */
    public static postApiTeamPost(
        requestBody?: Team,
    ): CancelablePromise<Team> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Team/Post',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param code
     * @param vehicleData
     * @returns any OK
     * @throws ApiError
     */
    public static putApiTeamChangeVehicleData(
        code?: string,
        vehicleData?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Team/ChangeVehicleData',
            query: {
                'code': code,
                'vehicleData': vehicleData,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static putApiTeamUpdateAdminSettings(
        requestBody?: TeamAdminSettingsRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Team/UpdateAdminSettings',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param temaCode
     * @param newLeadUserUId
     * @returns any OK
     * @throws ApiError
     */
    public static postApiTeamChangeLead(
        temaCode?: string,
        newLeadUserUId?: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Team/ChangeLead',
            query: {
                'temaCode': temaCode,
                'newLeadUserUId': newLeadUserUId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
